import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Pages, stateType } from './types';

const initialState: stateType = {
  currentPage: Pages.LOADING,
  onboardingPage: 1,
  endGame: false,
};

export const pages = createSlice({
  name: 'pages',
  initialState,
  reducers: {
    setPage(state, action: PayloadAction<Pages>) {
      state.currentPage = action.payload;
    },
    setOnboardingPage(state, action: PayloadAction<boolean>) {
      state.onboardingPage = action.payload ? state.onboardingPage + 1 : state.onboardingPage - 1;
    },
    setEndGame(state, action: PayloadAction<boolean>) {
      state.endGame = action.payload;
    },
  },
});

export const { setPage, setOnboardingPage, setEndGame } = pages.actions;

export default pages.reducer;
